import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-point",
  "use": "icon-point-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-point\"><path d=\"M65.265 509.879a435.481 435.481 0 1 0 891.26 0 435.481 435.481 0 1 0-891.26 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol